import { useRef, type ChangeEvent } from "react";
import "./s62-photos.css";

/** Parent retains existing validation, replacement confirmation and draft state. */
export function S62AssistantAttachment({ onSelect, disabled = false }: {
  onSelect: (file: File) => void;
  disabled?: boolean;
}) {
  const photo = useRef<HTMLInputElement>(null);
  const pdf = useRef<HTMLInputElement>(null);
  function select(event: ChangeEvent<HTMLInputElement>) {
    const file = event.currentTarget.files?.[0];
    event.currentTarget.value = "";
    if (file) onSelect(file);
  }
  return <div className="s62-assistant-attachments" aria-label="Pièce jointe">
    <button type="button" className="attachment-button s62-attachment-photo" aria-label="Ajouter une photo" disabled={disabled} onClick={() => photo.current?.click()}>+</button>
    <input ref={photo} className="s62-hidden-input" type="file" accept="image/jpeg,image/png,image/webp" aria-label="Choisir une photo pour l’Assistant" disabled={disabled} onChange={select}/>
    <button type="button" className="attachment-button" aria-label="Ajouter un PDF" disabled={disabled} onClick={() => pdf.current?.click()}>PDF</button>
    <input ref={pdf} className="s62-hidden-input" type="file" accept="application/pdf" aria-label="Choisir un PDF pour l’Assistant" disabled={disabled} onChange={select}/>
  </div>;
}
